export default "__VITE_ASSET__LVQ067wy__"